var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMenuStakingOptions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#f1f1f1;}.b{fill:#7d8dd8;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-60 -180)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 25,
    cy: 25,
    r: 25,
    transform: "translate(60 180)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M4813-962h-14a2,2,0,0,1-2-2v-16a2,2,0,0,1,2-2h14a2,2,0,0,1,2,2v16A2,2,0,0,1,4813-962Zm-12.208-14.159a.749.749,0,0,0-.649.376.738.738,0,0,0-.076.568.746.746,0,0,0,.351.457l1.063.615A4.943,4.943,0,0,0,4801-972a5.015,5.015,0,0,0,4,4.9v1.217a.751.751,0,0,0,.75.75.751.751,0,0,0,.75-.75v-1.142a4.978,4.978,0,0,0,3.254-1.672l1.079.622a.749.749,0,0,0,.371.1.753.753,0,0,0,.652-.375.751.751,0,0,0-.274-1.025l-1.017-.586A4.938,4.938,0,0,0,4811-972a4.936,4.936,0,0,0-.483-2.145l1.065-.615a.743.743,0,0,0,.349-.457.743.743,0,0,0-.075-.568.752.752,0,0,0-.65-.376.733.733,0,0,0-.374.1l-1.158.667a4.983,4.983,0,0,0-3.175-1.583v-1.276a.75.75,0,0,0-.75-.749.751.751,0,0,0-.75.749v1.351a4.96,4.96,0,0,0-2.675,1.508l-1.158-.667A.741.741,0,0,0,4800.792-976.16ZM4806-969a3,3,0,0,1-3-3,3,3,0,0,1,3-3,3,3,0,0,1,3,3A3,3,0,0,1,4806-969Zm0-4a1,1,0,0,0-1,1,1,1,0,0,0,1,1,1,1,0,0,0,1-1A1,1,0,0,0,4806-973Z",
    transform: "translate(-4722 1177)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 20,
    height: 1.5,
    rx: 0.75,
    transform: "translate(73 215) rotate(-90)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMenuStakingOptions);
export default __webpack_public_path__ + "static/media/icon-menu-staking-options.f620a862620cc81389875ab951262c21.svg";
export { ForwardRef as ReactComponent };